import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { AiAvatar } from "../AiAvatar";
@Component({
    name: "ImgText",
    components: {
        AiAvatar
    }
})
export default class ImgText extends Vue {
    @Prop() readonly imgSrc: string;
    @Prop() readonly item: any;
    @Watch("imgSrc") getimgSrc(val) {}
    mounted() {
        const ViewerDom = this.$refs["ai_img_view"];
        // @ts-ignore
        const viewer = new Viewer(ViewerDom, {});
    }
}

//@ts-ignore
export { default as ImgText } from "./index.vue";
